import { ref, readonly } from 'vue';
import { api } from '@/api/client';
export function useDashboardAiSummary() {
    const state = ref({ status: 'idle' });
    async function refresh() {
        // If we already have data, show "updating" overlay rather than blinking loading skeleton.
        if (state.value.status === 'success') {
            state.value = { ...state.value, isUpdating: true };
        }
        else {
            state.value = { status: 'loading' };
        }
        try {
            const response = await api.GET('/v1/dashboard/ai-summary');
            if (response.error) {
                const status = response.response.status;
                if (status === 429) {
                    const retryAfter = parseInt(response.response.headers.get('Retry-After') ?? '300', 10);
                    state.value = {
                        status: 'error',
                        message: `AI summary will refresh in ${Math.ceil(retryAfter / 60)} minute(s).`,
                        retryAfterSeconds: retryAfter,
                    };
                    return;
                }
                state.value = {
                    status: 'error',
                    message: 'Summary unavailable — AI is temporarily offline.',
                };
                return;
            }
            const dto = response.data;
            if (!dto || dto.summary === null || dto.summary === undefined) {
                state.value = {
                    status: 'error',
                    message: 'Summary unavailable — AI is temporarily offline.',
                };
                return;
            }
            state.value = { status: 'success', data: dto, isUpdating: false };
        }
        catch {
            state.value = {
                status: 'error',
                message: 'Summary unavailable — AI is temporarily offline.',
            };
        }
    }
    return {
        state: readonly(state),
        refresh,
    };
}
